export default __webpack_public_path__ + "static/media/mentor_logo.41ffd1e8.png";